module.exports = __webpack_public_path__ + "img/one.f51c03d0.svg";